"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const GenericSelectionOverlay_1 = __importDefault(require("./GenericSelectionOverlay"));
const DocumentSettingsContext_1 = require("../../context/DocumentSettingsContext");
const generateDocumentStyles_1 = require("../../utils/generateDocumentStyles");
const api_1 = require("../../api");
const RichTextEditorToolbar_1 = __importDefault(require("../RichTextEditorToolbar"));
const SessionBuilderContext_1 = require("../../context/SessionBuilderContext");
const PPTPreview = ({ code, isDragging, isEditing }) => {
    const { settings } = (0, DocumentSettingsContext_1.useDocumentSettings)();
    const [editorHtml, setEditorHtml] = react_1.default.useState("");
    const { setGeneratedCode } = (0, SessionBuilderContext_1.useSessionBuilder)();
    const wasEditingRef = react_1.default.useRef(false);
    const slides = code.split('<div class="slide-break"></div>');
    // Wrap slides for editor display
    const wrapSlidesForEditor = (html) => {
        const parts = html.split('<div class="slide-break"></div>');
        return parts.map((s) => `<div class="ppt-slide"><div class="content">${s}</div></div>`).join("");
    };
    const htmlWithStyles = `
    <html>
      <head>
        <style>
          ${(0, generateDocumentStyles_1.generateDocumentStyles)(settings, api_1.DOC_TYPE.PPT)}
        </style>
      </head>
      <body>
        ${slides.map((s) => `<div class="">${s}</div>`).join('')}
      </body>
    </html>
  `;
    const editorContentStyle = `
    ${(0, generateDocumentStyles_1.generateDocumentStyles)(settings, api_1.DOC_TYPE.PPT)}
  `;
    // Keep editor HTML synced with incoming code
    react_1.default.useEffect(() => {
        setEditorHtml(wrapSlidesForEditor(code));
    }, [code]);
    // Unwrap from editor to raw joined with slide-breaks
    const unwrapFromEditor = (html) => {
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const nodes = Array.from(doc.querySelectorAll('.ppt-slide'));
            if (nodes.length === 0)
                return html;
            const contents = nodes.map((n) => {
                const c = n.querySelector('.content');
                return c ? c.innerHTML : '';
            });
            return contents.join('<div class="slide-break"></div>');
        }
        catch (_a) {
            return html;
        }
    };
    // Commit on exiting edit mode
    react_1.default.useEffect(() => {
        if (wasEditingRef.current && !isEditing) {
            // const raw = unwrapFromEditor(editorHtml);
            setGeneratedCode(editorHtml);
        }
        wasEditingRef.current = !!isEditing;
    }, [isEditing, editorHtml, setGeneratedCode]);
    // Remove stale commit block (handled above)
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { position: 'relative', height: '100%', overflow: 'hidden' }, children: isEditing ?
            (0, jsx_runtime_1.jsx)(RichTextEditorToolbar_1.default, { value: editorHtml, onChange: setEditorHtml, disabled: isDragging, contentStyle: editorContentStyle })
            :
                (0, jsx_runtime_1.jsx)(GenericSelectionOverlay_1.default, { code: htmlWithStyles, iframeStyle: { minHeight: '500px', overflowY: 'scroll' }, title: "PPT Preview", isDragging: isDragging }) }));
};
exports.default = PPTPreview;
